import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./DetalhesCobranca.css";
import { formatarDataBrasil } from "../../utils/utils";

export default function DetalhesCobranca() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cobranca, setCobranca] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [valor, setValor] = useState("");
  const [vencimento, setVencimento] = useState("");
  const [tipoPagamento, setTipoPagamento] = useState("");
  const [status, setStatus] = useState("");
  const [dataPagamento, setDataPagamento] = useState("");


  useEffect(() => {
    async function fetchCobranca() {
      try {
        const response = await fetch(`https://welaunchyou.com.br/crm-wly/api/financeiro/detalhes_cobranca.php?id=${id}`);
        const data = await response.json();
        console.log("📌 Detalhes da cobrança:", data);
        setCobranca(data);
        setValor(data.valor);
        setVencimento(convertToISO(data.vencimento));
        setTipoPagamento(data.tipo_pagamento);
        setStatus(data.status);
        setDataPagamento(data.data_pagamento ? convertToISO(data.data_pagamento) : "");
      } catch (error) {
        console.error("Erro ao buscar detalhes da cobrança", error);
      } finally {
        setLoading(false);
      }
    }
    fetchCobranca();
  }, [id]);
  
  
  const convertToISO = (dateStr) => {
    // Verifica se a data está preenchida
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };
  
  if (loading) return <p>Carregando...</p>;
  if (!cobranca) return <p>Cobrança não encontrada.</p>;

  const cancelarCobranca = async () => {
    if (!window.confirm("Tem certeza que deseja cancelar esta cobrança?")) {
      return;
    }

    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/api/financeiro/cancelar_cobranca.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_transacao_asaas: cobranca.id_transacao_asaas }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Cobrança cancelada com sucesso!");
        navigate("/financeiro");
      } else {
        alert("Erro ao cancelar: " + data.error);
      }
    } catch (error) {
      console.error("Erro ao cancelar cobrança", error);
      alert("Erro ao conectar com o servidor.");
    }
  };

  const editarCobranca = async () => {
    if (!window.confirm("Deseja salvar as alterações desta cobrança?")) {
      return;
    }
  
    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/api/financeiro/editar_cobranca.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_transacao_asaas: cobranca.id_transacao_asaas,
          valor: parseFloat(valor),
          vencimento,
          data_pagamento: dataPagamento,
          tipo_pagamento: tipoPagamento,
          status: status.toUpperCase()
        }),
      });
  
      const data = await response.json();
  
      if (data.success) {
        alert("Cobrança editada com sucesso!");
        setModoEdicao(false);
        navigate(`/financeiro/detalhes/${id}`);
      } else {
        alert("Erro ao editar: " + data.error);
      }
    } catch (error) {
      console.error("Erro ao editar cobrança", error);
      alert("Erro ao conectar com o servidor.");
    }
  };
  

  return (
    <div className="detalhes-cobranca-container">
      <button className="voltar-button" onClick={() => navigate(-1)}>← Voltar</button>

      <h2 className="detalhes-cobranca-title">Detalhes da Cobrança</h2>

      {!modoEdicao ? (
        <div className="detalhes-cobranca-card">
          <p><strong>Cliente:</strong> {cobranca.cliente}</p>
          <p><strong>Valor:</strong> R$ {parseFloat(cobranca.valor).toFixed(2)}</p>
          <p><strong>Forma de Pagamento:</strong> {cobranca.tipo_pagamento}</p>
          <p><strong>Status:</strong> {cobranca.status}</p>
          <p><strong>Vencimento:</strong> {formatarDataBrasil(cobranca.vencimento)}</p>
          <p><strong>Data de Pagamento:</strong>{" "}{cobranca.data_pagamento ? formatarDataBrasil(cobranca.data_pagamento) : '-'}</p>
        </div>
      ) : (
        <div className="editar-cobranca-form">
           <label>Cliente:</label>
           <input type="text" value={cobranca.cliente} disabled />
           
          <label>Valor (R$):</label>
          <input type="number" step="0.01" value={valor} onChange={(e) => setValor(e.target.value)} />

          <label>Data de Vencimento:</label>
          <input type="date" value={vencimento} onChange={(e) => setVencimento(e.target.value)} />

          <label>Data de Pagamento:</label>
          <input type="date" value={dataPagamento} onChange={(e) => setDataPagamento(e.target.value)} />


          <label>Forma de Pagamento:</label>
          <select value={tipoPagamento} onChange={(e) => setTipoPagamento(e.target.value)}>
            <option value="BOLETO">Boleto</option>
            <option value="PIX">PIX</option>
            <option value="CREDIT_CARD">Cartão de Crédito</option>
          </select>

          <label>Status:</label>
<select value={status} onChange={(e) => setStatus(e.target.value)}>
  <option value="COBRADO">COBRADO</option>
  <option value="PAGO">PAGO</option>
  <option value="CANCELADO">CANCELADO</option>
  <option value="ATRASADO">ATRASADO</option>
</select>

        </div>
      )}

      <div className="detalhes-cobranca-botoes">
        {!modoEdicao ? (
          <>
            <button className="botao editar" onClick={() => setModoEdicao(true)}>Editar</button>
            <button className="botao cancelar" onClick={cancelarCobranca}>Apagar</button>
          </>
        ) : (
          <>
            <button className="botao salvar" onClick={editarCobranca}>Salvar</button>
            <button className="botao cancelar" onClick={() => setModoEdicao(false)}>Cancelar Edição</button>
          </>
        )}
      </div>
    </div>
  );
}
